import { render, staticRenderFns } from "./BlogFilterMenu.vue?vue&type=template&id=f5da4ce8"
import script from "./BlogFilterMenu.vue?vue&type=script&lang=ts"
export * from "./BlogFilterMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports